import type React from "react"

import type { Site } from "@/models/site"

import { Box, Slide, useTheme } from "@mui/material"

import { SiteInfo } from "../../components/siteInfo/siteInfo"

interface SiteInfoPanelProps {
  isOpen: boolean
  onClose: () => void
  site: Site
}

export const SiteInfoPanel: React.FC<SiteInfoPanelProps> = ({
  isOpen,
  onClose,
  site,
}) => {
  const theme = useTheme()

  return (
    <Slide direction="left" in={isOpen} unmountOnExit>
      <Box
        sx={{
          bottom: "24px",
          position: "fixed",
          right: 0,
          top: "72px",
          width: theme.typography.pxToRem(360),
          zIndex: 1200,
        }}
      >
        <SiteInfo onClose={onClose} site={site} />
      </Box>
    </Slide>
  )
}
